import { forwardRef } from "react"
import { createPrefixOfResource } from "../../common"

const VideoComp = forwardRef(({src, ...props}, ref) => (
    <video ref={ref} {...props}>
        <source src={`${createPrefixOfResource()}${src}`} />
    </video>
))

export default VideoComp